import { useEffect } from "react";
import axios from "axios";

import Form from "./components/Form";


import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import GlobalStyle from "../../styles/global-new.js";
import fundo2 from "../../styles/fundo2.svg";


const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh; 
  background-image: url(${fundo2});
  //background-color: #f7f7f7;

`;




function Login() {

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('token');



  const getToken = async () => {
    try {
      const res = await axios.get(`${urlApi}logon/token`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data) {
        // Token válido, redireciona para a rota desejada
        window.location.href = `${urlFront}`;
      }
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {

      } else {
        console.error("Erro ao obter token:", error);

      }
    }

  };

  useEffect(() => {
    getToken();
  }, []);


  return (
    <Div>


      <Form urlApi={urlApi} />
      <ToastContainer
        autoClose={1500}
        position={toast.POSITION.BOTTOM_LEFT}
        style={{ width: '400px', fontSize: '22px' }}
      />
      <GlobalStyle />
    </Div>
  );
}

export default Login;
